import RoundedBoxComponent from "../race/block/RoundedBoxComponent.jsx";
import Tree from "../trees/Tree.jsx";
import FloorBlock from "../race/block/FloorBlock.jsx";
import ExplanationMovement from "../explanation/ExplanationMovement.jsx";
import { COLORS } from "../../constants/colors";
import MiniTreeGreen from "../trees/MiniTreeGreen.jsx";
import TrianglePyramid from "../pyramids/TrianglePyramid.jsx";
import TowerPyramid from "../pyramids/TowerPyramid.jsx";

import WallPyramid from "../pyramids/WallPyramid.jsx";
const StartLocation = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <FloorBlock position={[-2.75, 0, -3]} scale={0.7} />
      <FloorBlock position={[-4.75, 0, 0]} scale={0.7} />
      <FloorBlock position={[-2.75, 0, 3]} scale={0.7} />
      <FloorBlock position={[-4.75, 0, 6]} scale={0.7} />
      <FloorBlock position={[-2.75, 0, 9]} scale={0.7} />
      <FloorBlock position={[-4.75, 0, 12]} scale={0.7} />
      <FloorBlock position={[-2.75, 0, 15]} scale={0.7} />
      <FloorBlock position={[-4.75, 0, 18]} scale={0.7} />
      <TowerPyramid
        position={[-3.75, 0, -12]}
        rotation={[0, Math.PI / 4, 0]}
        color={COLORS.green}
      />
      <WallPyramid
        position={[-13.75, 0, -2]}
        rotation={[0, Math.PI / 2, 0]}
        color={COLORS.green}
      />

      <WallPyramid
        position={[-13.75, 0, 3]}
        rotation={[0, Math.PI / 2, 0]}
        color={COLORS.green}
      />
      <MiniTreeGreen position={[2.25, 0, -12]} rotation={[0, 0, 0]} />
      <MiniTreeGreen position={[11.25, 0, -12]} rotation={[0, 0, 0]} />
      <MiniTreeGreen position={[13.75, 0, -9]} rotation={[0, 0, 0]} />
      <MiniTreeGreen position={[13.75, 0, -2]} rotation={[0, 0, 0]} />
      <TrianglePyramid
        position={[6.95, 0, -12.2]}
        rotation={[0, 0, 0]}
        color={COLORS.green}
      />
      <TrianglePyramid
        position={[13.75, 0, -6]}
        rotation={[0, Math.PI / 2, 0]}
        color={COLORS.green}
      />
      <Tree position={[-8.75, 0, -7]} rotation={[0, 0, 0]} />
      <ExplanationMovement position={[2.25, -0.98, -9]} rotation={[0, 0, 0]} />
    </group>
  );
};

export default StartLocation;
